import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { Card, Flex, Text, Title } from '@mantine/core';

import { LBActionButton, LBRingProgress } from '@/shared/ui-kit/components';

import styles from './CompletionNotification.module.css';

type LBCompletionNotificationProps = {
  value: number;
  description: string;
  title: string;
  onNavigate: () => void;
};

export const LBCompletionNotification = ({
  value,
  description,
  title,
  onNavigate
}: LBCompletionNotificationProps) => (
  <Card className={styles.container} onClick={onNavigate}>
    <Flex>
      <Flex direction='column' gap={8} w='100%'>
        <Flex align='center' justify='space-between'>
          <Title order={4}>{title}</Title>
          <LBRingProgress value={value} />
        </Flex>
        <Text fz={14}>{description}</Text>
      </Flex>
    </Flex>

    <Flex align='center' justify='end'>
      <LBActionButton onClick={onNavigate}>
        <ArrowRightIcon height={18} width={18} />
      </LBActionButton>
    </Flex>
  </Card>
);
